const dryCleaningMan = [
	{
		id: '4101',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Top Wear (Shirt / T-shirt / Trouser / Pajama)',
		category: "Men's Wear",
		service: 'Dry Cleaning',
		price: 40,
		quantity: 1
	},
	{
		id: '4102',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Suit (2 Pcs)',
		category: "Men's Wear",
		service: 'Dry Cleaning',
		price: 200,
		quantity: 1
	},
	{
		id: '4103',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Suit (3 Pcs)',
		category: "Men's Wear",
		service: 'Dry Cleaning',
		price: 250,
		quantity: 1
	},
	{
		id: '4104',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Jacket / Trench Coat',
		category: "Men's Wear",
		service: 'Dry Cleaning',
		price: 100,
		quantity: 1
	},
	{
		id: '4105',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Kanzu',
		category: "Men's Wear",
		service: 'Dry Cleaning',
		price: 120,
		quantity: 1
	},
	{
		id: '4106',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Leather Jacket',
		category: "Men's Wear",
		service: 'Dry Cleaning',
		price: 100,
		quantity: 1
	},
	{
		id: '4107',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Mens Kitenge (1pcs)',
		category: "Men's Wear",
		service: 'Dry Cleaning',
		price: 50,
		quantity: 1
	},
	{
		id: '4108',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Kitenge (2pcs)',
		category: "Men's Wear",
		service: 'Dry Cleaning',
		price: 150,
		quantity: 1
	},
	{
		id: '4109',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Shoes',
		category: "Men's Wear",
		service: 'Dry Cleaning',
		price: 40,
		quantity: 1
	},

	{
		id: '4110',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Winter Wear (Sweater / Hoodies)',
		category: "Men's Wear",
		service: 'Dry Cleaning',
		price: 120,
		quantity: 1
	}
];

export default dryCleaningMan;
